import { flexComponentMap } from "components/flexFramework/FlexComponents/flexComponentMap";
import { Logger } from "bernie-logger";
import { CodeSplit } from "bernie-core";
import { ServerSideLogger } from "components/utility/ServerSideLogger";
import { UNSUPPORTED_MODULE } from "config/systemEvents";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { FlexModuleStore } from "src/stores/FlexModuleStore";

export interface ComponentData {
  id: string;
  name: string;
  fmId: number;
  fmTitleId?: number;
  view?: string;
  ajaxOnly?: boolean;
  clientSideOnly?: boolean;
  scene?: string;
  children?: NewBlossomComponent[];
  model: object | null;
}

export class NewBlossomComponent {
  public id: string;
  public name: string;
  public fmId: number;
  public fmTitleId?: number;
  public view?: string;
  public ajaxOnly: boolean;
  public clientSideOnly: boolean;
  public scene?: string;
  public children?: NewBlossomComponent[];
  public reactComponent?: CodeSplit; //TODO: this typing isn't exactly right #confused
  public webpackChunkName?: string;
  public getModel: () => {};

  public constructor(
    componentData: ComponentData,
    context: ExtendedContextStore,
    flexModuleStore: FlexModuleStore,
    logger?: Logger
  ) {
    const { id, name, fmId, fmTitleId, view, ajaxOnly, clientSideOnly, scene, children, model } = componentData;
    this.id = id;
    this.name = name;
    this.fmId = fmId;
    this.fmTitleId = fmTitleId;
    this.view = view;
    this.ajaxOnly = ajaxOnly ? ajaxOnly : false;
    this.clientSideOnly = clientSideOnly ? clientSideOnly : false;
    this.scene = scene;
    this.children = children;

    /**
     * returns model from FlexModuleStore matching the BlossomComponent's id
     * FlexModuleStore will be serialized so referencing this as a function to avoid
     * duplication during serialization of TemplateStore and CompositionStore
     */
    this.getModel = () => flexModuleStore.modelMap.get(this.id) || {};

    const componentMapping = this.getComponentMapping();

    if (componentMapping === undefined) {
      if (logger) {
        this.logUnsupportedModule(logger, context);
      }
      this.reactComponent = undefined;
      this.webpackChunkName = undefined;
    } else {
      flexModuleStore.updateModelMap(this.id, model ? model : {});
      this.reactComponent = componentMapping.codeSplit;
      this.webpackChunkName = componentMapping.webpackChunkName;
    }
  }

  /**
   * returns corresponding mapping object from flexComponetMap using it's name and view
   * Naming convention: <module name>_<view>
   * @returns FlexComponentMapOptions|undefined
   */
  private getComponentMapping = () => {
    if (!flexComponentMap.has(this.name)) {
      return undefined;
    }

    const viewSpecificComponentName = `${this.name}_${this.view}`;
    if (this.view !== undefined && flexComponentMap.has(viewSpecificComponentName)) {
      return flexComponentMap.get(viewSpecificComponentName);
    }

    return flexComponentMap.get(this.name);
  };

  /**
   * Takes the name of a Flex component found in a composition that had no corresponding Flex UI Component, and reports it to the server side logger
   */
  private logUnsupportedModule = (logger: Logger, context: ExtendedContextStore) => {
    const contextualInfo = Object.entries({
      pageType: context && context.searchContext && context.searchContext.pageType,
      deviceId: context && context.deviceId,
      userAgent: context && context.userAgent,
      langId: context && context.langId,
      locale: context && context.locale,
      siteId: context && context.site && context.site.id,
      requestId: context && context.traceInfo && context.traceInfo["Trace-ID"],
    })
      .map((key, value) => `${key}=\"${value}\"`)
      .toString();

    ServerSideLogger(logger!).logEvent(
      UNSUPPORTED_MODULE,
      `moduleName=${this.name} is not currently supported by this view layer application`,
      contextualInfo
    );
  };
}
